import React, { useMemo, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    Box,
    TextField,
    IconButton,
    Typography,
    useTheme,
    alpha,
    Snackbar,
    Alert
} from "@mui/material";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ShareIcon from "@mui/icons-material/Share";
import { useUser } from "../../contexts/userContext";
import { Portal } from "@mui/material";
import LoginRegisterDialog from "./login";
import { DOMAIN } from "../../config";
import CryptoJS from "crypto-js";


export default function ShareSilverDialog({ open, onClose, video }) {
    const { userData, setUserData } = useUser();
    const theme = useTheme();

    // ---------------- Snackbar 状态 ----------------
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");

    const showMessage = (msg) => {
        setSnackbarMessage(msg);
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    // ---------------------- links -----------------------
    const rows = useMemo(() => {
        if (!userData?.id) return [];

        const hasAgent = !!userData?.agent;
        const agent = userData?.agent;

        // 小程序链接
        const miniProgramUrl = hasAgent
            ? `https://t.me/ywywebappbot/app?startapp=shareuser_${userData.id}_photo_${video.id}_agent_${agent}`
            : `https://t.me/ywywebappbot/app?startapp=shareuser_${userData.id}_photo_${video.id}`;

        // 网站链接
        const websiteUrl = hasAgent
            ? `https://www.52ywy.com?shareuser=${userData.id}&agent=${agent}`
            : `https://www.52ywy.com?shareuser=${userData.id}`;

        return [
            {
                label: "小程序链接（推荐）",
                url: miniProgramUrl,
            },
            {
                label: "网站链接",
                url: websiteUrl,
            },
        ];
    }, [userData, video]);


    const handleCopy = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            showMessage("复制成功！");
        } catch (err) {
            console.error("复制失败:", err);
            showMessage("复制失败");
        }
    };

    const handleShare = (url) => {
        if (window.Telegram?.WebApp) {
            window.Telegram.WebApp.openTelegramLink(
                `https://t.me/share/url?url=${url}&text=${video.caption}`
            );
        } else {
            showMessage("请在 Telegram 小程序内使用转发功能");
        }
    };

    // ---------------------- VIP 兑换 -----------------------
    const handleExchangeVip = async () => {
        if (!userData?.id) return;

        if (userData.silver < 70) {
            showMessage("银币不足！");
            return;
        }

        try {
            const userId = userData.id;
            const apiKey = process.env.REACT_APP_API_KEY;
            const timestamp = Date.now().toString();

            // 生成签名
            const raw = `${userId}:${timestamp}`;
            const sign = CryptoJS.HmacSHA256(raw, apiKey).toString();

            const res = await fetch(
                `${DOMAIN}lukcy/silverBuyVip?userId=${userId}&ts=${timestamp}&sign=${sign}`
            )
            const data = await res.json()

            if (data.code !== 0) {
                showMessage("兑换失败：" + data.message);
                return;
            }

            // 🔥 扣除 70 银币
            setUserData((prev) => ({
                ...prev,
                silver: (prev.silver ?? 0) - 70,
                vip: true, // 如果你有 vip 字段可以这样写，没有可以删掉
            }));

            showMessage("兑换成功，为您开通了31天会员，刷新一下小程序你的会员数据就会更新出来了！")
        } catch (e) {
            console.error(e);
            showMessage("兑换失败");
        }
    };

    // ---------------------- UI -----------------------
    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: 4,
                        paddingBottom: 1,
                        boxShadow:
                            "0 20px 40px rgba(0,0,0,.15), 0 4px 10px rgba(0,0,0,.08)",
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        fontWeight: 600,
                        fontSize: "1.3rem",
                        textAlign: "center",
                        paddingTop: 3,
                        paddingBottom: 1,
                        position: "relative",
                    }}
                >
                    分享换银币

                    <IconButton
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: "text.secondary",
                        }}
                    >
                        ×
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ pt: 1 }}>
                    <Typography
                        sx={{
                            mb: 3,
                            color: "text.secondary",
                            fontSize: 14,
                            textAlign: "left",
                            lineHeight: 1.6,
                        }}
                    >
                        分享你的专属链接，好友点击即可为你带来银币奖励。
                        你分享的越多，我们就能邀请更多同好夫妻加入。
                    </Typography>

                    <Box sx={{ mb: 3 }}>
                        <Typography
                            sx={{
                                fontSize: 16,
                                fontWeight: 600,
                                textAlign: "left",
                                color: theme.palette.primary.main,
                            }}
                        >
                            当前银币：{userData?.silver ?? 0} 枚
                        </Typography>
                    </Box>

                    {rows.map((row, idx) => (
                        <Box key={idx} sx={{ mb: 3 }}>
                            <Typography
                                sx={{
                                    mb: 1,
                                    fontSize: 14,
                                    color: "text.primary",
                                    fontWeight: 500,
                                }}
                            >
                                {row.label}
                            </Typography>

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1.2,
                                }}
                            >
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={row.url}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    sx={{
                                        "& .MuiInputBase-root": {
                                            borderRadius: 3,
                                            background: "#f5f5f7",
                                            border: "1px solid #e6e6e8",
                                            paddingLeft: 1.2,
                                            fontSize: 13,
                                        },
                                    }}
                                />

                                <IconButton
                                    onClick={() => handleCopy(row.url)}
                                    sx={{
                                        backdropFilter: "blur(10px)",
                                        background: alpha("#fff", 0.5),
                                        borderRadius: "12px",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                        "&:hover": {
                                            background: alpha("#fff", 0.8),
                                        },
                                    }}
                                >
                                    <ContentCopyIcon fontSize="small" />
                                </IconButton>

                                <IconButton
                                    onClick={() => handleShare(row.url)}
                                    sx={{
                                        backdropFilter: "blur(10px)",
                                        background: alpha("#fff", 0.5),
                                        borderRadius: "12px",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                        "&:hover": {
                                            background: alpha("#fff", 0.8),
                                        },
                                    }}
                                >
                                    <ShareIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        </Box>
                    ))}

                    <Box sx={{ mt: 4, mb: 2 }}>
                        <Button
                            fullWidth
                            onClick={handleExchangeVip}
                            sx={{
                                paddingY: 1.2,
                                paddingX: 2,
                                borderRadius: 3,
                                fontSize: 12,
                                fontWeight: 600,
                                background: "linear-gradient(90deg, #7b61ff, #5ac8fa)",
                                color: "#ffffff",
                                textTransform: "none",
                                boxShadow: "0 4px 12px rgba(0,0,0,.12)",
                                "&:hover": {
                                    background: "linear-gradient(90deg, #6a54ff, #4abdf5)",
                                },
                            }}
                        >
                            兑换会员（70银币）
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* ---------------- Snackbar ---------------- */}
            <Portal>
                <Snackbar
                    open={snackbarOpen}
                    onClose={handleSnackbarClose}
                    autoHideDuration={3000}
                    sx={{
                        zIndex: 99999,
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "auto",
                        maxWidth: 300,
                    }}
                >
                    <Box
                        sx={{
                            background: "rgba(0, 0, 0, 0.7)",   // 半透明黑
                            color: "#fff",                      // 白字
                            padding: "12px 20px",
                            borderRadius: "12px",
                            textAlign: "center",
                            fontSize: "15px",
                            backdropFilter: "blur(6px)",        // 轻微玻璃效果
                            boxShadow: "0 4px 16px rgba(0,0,0,.3)",
                        }}
                    >
                        {snackbarMessage}
                    </Box>
                </Snackbar>
            </Portal>




        </>
    );
}
